module.exports = __webpack_public_path__ + "static/media/Joffrey Baratheon 1.37397f16.jpg";